import type { StorageKey } from './StorageKey';

// Absent outside the browser (tests, SSR); accessing or writing it can also throw (storage disabled,
// quota exceeded), so every call degrades to "nothing stored".
const backend = (): Storage | undefined => {
  try {
    return typeof localStorage === 'undefined' ? undefined : localStorage;
  } catch {
    return undefined;
  }
};

/** Typed access to localStorage: keys must come from the `StorageKey` registry. */
export const storage = {
  get(key: StorageKey): string | null {
    try {
      return backend()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  set(key: StorageKey, value: string): void {
    try {
      backend()?.setItem(key, value);
    } catch {
      // Not persisted; the in-memory state still updates.
    }
  },
  remove(key: StorageKey): void {
    try {
      backend()?.removeItem(key);
    } catch {
      // Nothing to clean up.
    }
  },
};
